export const ROUTES = {
  CATALOG: {
    NAME: "Catalog",
    PATH: "/catalog",
  },
  SEARCH: {
    NAME: "Search",
    PATH: "/search",
  },
} as const;
